import script from "./VoucherCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherCarousel.vue?vue&type=style&index=0&id=ce55672e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce55672e"]])

export default __exports__